var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer2 = function SvgNumTimer2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M2.067 18.896q0-1.68.768-2.448.768-.792 2.472-.792h8.016v-4.248H2.067V7.52H14.69q1.68 0 2.448.768.792.768.792 2.472v5.448q0 1.68-.768 2.472-.768.768-2.472.768H6.675v5.664H17.93V29H2.067z"
  })));
};
export default SvgNumTimer2;